import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { useMemo } from 'react';
import { propArrayShape, propFunc, propBool, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import SlideSearchItemsInner from './SlideSearchItemsInner';
import SlideSearchItemSkeletons from './SlideSearchItemSkeletons';
const SlideSearchItems = (props) => {
    const { keyword, loading, onChange, onClickSlideSearchLink, rows: rawRows, selectMap, unit, } = props;
    const rows = useMemo(() => _.chunk(rawRows, 2).map((v) => ({
        columns: v,
        id: v.map((innerValue) => innerValue.id).join('_'),
    })), [rawRows]);
    return (_jsx("div", Object.assign({ className: 'slide_search_list_content_items' }, { children: loading ? (_jsx(SlideSearchItemSkeletons, {})) : (_jsx(SlideSearchItemsInner, { items: rawRows, keyword: keyword, onChange: onChange, onClickSlideSearchLink: onClickSlideSearchLink, rows: rows, selectMap: selectMap, unit: unit })) })));
};
SlideSearchItems.propTypes = {
    keyword: propStr(),
    loading: propBool().isRequired,
    onChange: propFunc().isRequired,
    onClickSlideSearchLink: propFunc(),
    rows: propArrayShape().isRequired,
    selectMap: propShape().isRequired,
    unit: propShape().isRequired,
};
SlideSearchItems.defaultProps = {
    keyword: '',
    onClickSlideSearchLink: null,
};
export default SlideSearchItems;
